/**
 * Session-mode helpers.
 *
 * The server reports `fEview` (this NVR is licensed/capable of eView). The
 * user toggles `useEviewLogin` (intent to log in across multiple NVRs).
 * These are NOT interchangeable: a normal single-NVR login to an
 * eView-licensed NVR has fEview=true but useEviewLogin=false. In that
 * state, eView code paths that read from state.server.allCameras
 * (cross-server camera union) fail because the multi-NVR connect only
 * runs for actual eView sessions, so allCameras is empty.
 *
 * Use isMultiServerSession(state) to gate eView vs dview behavior in
 * components and actions. It returns true only when the current session
 * is actually operating across multiple servers.
 */

export const isMultiServerSession = (state) =>
  !!state.auth?.useEviewLogin ||
  (!!state.server?.fEview && (state.server?.allCameras?.length || 0) > 0);
